import { ItembudgetCategory } from "./item-budget-category.model";

export class BudgetCategory {
    id?: string;
    ordem?: number;
    nome?: string;
    apresentarEmOrcamento?: boolean;
    tipoDeCalculo?: number;
    tipoDeApresentacao?: number;
    tipoDeDespesa?: number;
    itens?: ItembudgetCategory[];
}